import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { TopsellerService } from '../topseller.service';
import { Global } from '../classes/Global';
import { Log } from '../helpers/Log';
import { StorageHelper } from '../helpers/StorageHelper';
import { WishlistService } from '../wishlist.service';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

@Component({
  selector: 'app-itunes-movies-4k',
  templateUrl: './itunes-movies-4k.component.html',
  styleUrls: ['./itunes-movies-4k.component.scss'],
  providers: [TopsellerService, WishlistService]
})
export class ItunesMovies4KComponent extends BaseComponent implements OnInit {

  items;
  schema;

  constructor(
    private topSellerService: TopsellerService,
    private wishListService: WishlistService
  ) {
    super();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.schema = AiStructuredDataHelper.buildDealsPageSchema(
      this.getString('itunesMovies4K'),
      "https://www.cheapcharts.com/" + Global.getCountry() + "/" + this.getString('itunesMovies4KUrl'),
      Global.getCountry(),
      Global.ITUNES,
      Global.BUYMOVIES,
      "4k"
    );
    this.topSellerService.getTopSellersForStartPage(Global.getCountry(), 5).subscribe(res => {
      if (res && res["results"]) {
        this.items = res["results"][Global.ITUNES];
      }
    }, err => {
      Log.getInstance().d(err);
    });
  }

  getLang(): string {
    return InternationalizationHelper.getTwoCharactersLanguage();
  }

  wishListClicked(item) {
    const id = item.idInStore || item.itemID;
    this.wishListService.addItem(Global.getCountry(), Global.ITUNES, Global.getMediaType(),
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
        this.getShortWishList(Global.ITUNES);
      }, err => {

      });
  }

  getShortWishList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken) {
      this.wishListService.getShortWishlist(
        Global.getCountry(),
        store,
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[store] = res["results"];
          StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        }
      },
        err => {
          Log.getInstance().d(err);
        });
    }

  }

}
